import { Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { useLoaderData } from "react-router-dom"
import { MainContainer } from "../../components/MainContainerComp"
import { doFetch } from "../../utils/doFetch"

export const dispatchConfirmationReceiptRouteLoader = async ({ request, params }: { request: any, params: any }) =>
  doFetch(
    `my-dispatch-confirmation-receipt/${params.orderDetailId}`,
    {
      signal: request.signal, headers: {
        'Content-Type': 'text/plain',
      }
    },
    true,
    true,
  )

export const DispatchConfirmationReceiptRoute = () => {
  const data = useLoaderData() as Blob;
  const [textContent, setTextContent] = useState<string | ArrayBuffer | null>(null);

  useEffect(() => {
    if (data) {
      const reader = new FileReader();

      reader.onload = () => {
        const result = reader.result;
        setTextContent(result);
      };

      reader.readAsText(data);
    }
  }, [data]);

  return (
    <MainContainer>
      <Typography sx={{ padding: 2 }}>
        <pre style={{ whiteSpace: 'pre-wrap' }}>{textContent as unknown as string}</pre>
      </Typography>
    </MainContainer>
  )
}